import React from 'react'
import { Respondent } from '../../../types/Respondent'
import { OscInput } from '../OscInputs/OscInput'
import { TelInput } from '../OscInputs/TelInput'

export const RespondenetFields = ({respondent}:Props) => {
    return (
        <>
        <div className='font-semibold text-gray-700 my-2 text-md'>Identificação Do Respondente</div>
        <div className='grid gap-x-6 gap-y-2 grid-cols-1 md:grid-cols-2 text-gray-800 mt-6 '>

            <OscInput necessary label={'Nome do responsável pelas respostas'} name='respondent[0][name]' defaultValue={respondent?.name && respondent.name}  required />

            <OscInput necessary label={'Qual a sua formação?'} name='respondent[0][formation]'  required defaultValue={respondent?.formation && respondent.formation}  />

            <OscInput necessary label={'Há quanto tempo você atua na organização (independentemente do cargo)'}
                        name={"respondent[0][time_at_osc]"}  required
                        defaultValue={respondent?.time_at_osc && respondent.time_at_osc}
            />
            <OscInput necessary label={'Cargo / função da pessoa que está preenchendo o formulário  '}
                        name={"respondent[0][position]"}  required
                        defaultValue={respondent?.position && respondent.position}
            />

            <TelInput label={'Telefone do responsável pelas respostas'} type={"tel"} name='respondent[0][phone]'  required necessary
                    defaultValue={respondent?.phone && respondent.phone}
            />
            <OscInput necessary label={'E-mail do responsável pelas respostas'} type={'email'} name='respondent[0][email]'  required
                    defaultValue={respondent?.email && respondent.email}
            />
        </div>
        </>
    )
}

interface Props {
    respondent?:Respondent
}
